"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isMeasureMetadataObjectDefinition = exports.isMeasureMetadataObject = void 0;
// (C) 2019-2021 GoodData Corporation
var types_1 = require("../types");
/**
 * Tests whether the provided object is of type {@link IMeasureMetadataObject}.
 *
 * @param obj - object to test
 * @public
 */
function isMeasureMetadataObject(obj) {
    return types_1.isMetadataObject(obj) && obj.type === "measure";
}
exports.isMeasureMetadataObject = isMeasureMetadataObject;
/**
 * Tests whether the provided object is of type {@link IMeasureMetadataObjectDefinition}.
 *
 * @param obj - object to test
 * @public
 */
function isMeasureMetadataObjectDefinition(obj) {
    return obj.type === "measure" && obj.ref === undefined;
}
exports.isMeasureMetadataObjectDefinition = isMeasureMetadataObjectDefinition;
//# sourceMappingURL=index.js.map